var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "@emotion/react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { AttributeIconPicker, AttributeIconPickerOption, } from '../AttributeIconPicker';
import { LongTextPicker, LongTextPickerOption, } from '../LongTextPicker';
import { OptionSelectorHeading, } from '../OptionSelectorHeading';
import { Picker, PickerOption, } from '../Picker';
import { Select, } from '../Select';
import { ShortTextPicker, ShortTextPickerOption, } from '../ShortTextPicker';
import { Swatch, SwatchPicker, } from '../SwatchPicker';
import { CustomColorSwatch, } from '../SwatchPicker/CustomColorSwatch';
import { AttributeFilter, } from './AttributeFilter';
import { SelectorDisplay, } from './SelectorDisplay';
const containerStyles = css `
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing.x4};
  width: 100%;
`;
const defaultProps = {
    onChange: () => { },
    optionType: 'shortText',
};
const OptionSelector = (_a) => {
    var { attributeFilterOptions, description, disabled, headingLayout, horizontalPadding, isLoading, name, onChange = defaultProps.onChange, optionLayout, options, optionType = defaultProps.optionType, value } = _a, props = __rest(_a, ["attributeFilterOptions", "description", "disabled", "headingLayout", "horizontalPadding", "isLoading", "name", "onChange", "optionLayout", "options", "optionType", "value"]);
    const optionSelectorHeadingContainerStyles = useMemo(() => (css `
        ${horizontalPadding && css `
          padding-left: ${styleUtils.rem(horizontalPadding)};
          padding-right: ${styleUtils.rem(horizontalPadding)};
        `}
      `), [
        horizontalPadding,
    ]);
    const optionComponents = useMemo(() => (options === null || options === void 0 ? void 0 : options.map((option, index) => {
        if (optionType === 'attributeIcon') {
            return (
            /* @ts-expect-error 2322 `path` is only conditionally a prop */
            _jsx(AttributeIconPickerOption, { disabled: 'disabled' in option ? option.disabled : undefined, iconType: 'iconType' in option ? option.iconType : 'nonePortrait', id: 'id' in option ? option.id : undefined, path: 'path' in option ? option.path : '', value: option.value }, index));
        }
        else if (optionType === 'custom'
            || optionType === 'customDefault'
            || optionType === 'customSwatch') {
            return (_jsx("div", Object.assign({ css: css `width: fit-content;` }, { children: _jsx(PickerOption, Object.assign({ disabled: disabled || ('disabled' in option ? option.disabled : undefined), id: 'id' in option ? option.id : undefined, value: option.value }, { children: 'children' in option ? option.children : null })) }), index));
        }
        else if (optionType === 'swatch') {
            return (_jsx(Swatch, { color: 'color' in option ? option.color : theme.colors.gray100, displayName: 'displayName' in option ? option.displayName : undefined, id: 'id' in option ? option.id : undefined, image: 'image' in option ? option.image : undefined, isDisabled: disabled || ('isDisabled' in option ? option.isDisabled : undefined), tooltipText: 'tooltipText' in option ? option.tooltipText : undefined, value: option.value }, index));
        }
        else if (optionType === 'shortText') {
            return (_jsx(ShortTextPickerOption, { description: 'description' in option ? option.description : undefined, disabled: disabled || ('disabled' in option ? option.disabled : undefined), iconPlacement: 'iconPlacement' in option ? option.iconPlacement : undefined, iconType: 'iconType' in option ? option.iconType : undefined, id: 'id' in option ? option.id : undefined, label: 'label' in option ? option.label : '', value: option.value }, index));
        }
        else if (optionType === 'longText') {
            return (_jsx(LongTextPickerOption, { additionalLabel: 'additionalLabel' in option ? option.additionalLabel : undefined, alt: 'alt' in option ? option.alt : undefined, description: 'description' in option ? option.description : undefined, disabled: disabled || ('disabled' in option ? option.disabled : undefined), iconType: 'iconType' in option ? option.iconType : undefined, id: 'id' in option ? option.id : undefined, label: 'label' in option ? option.label : '', src: 'src' in option ? option.src : undefined, value: option.value }, index));
        }
        return undefined;
    })), [
        disabled,
        options,
        optionType,
    ]);
    const attributeFilterComponent = useMemo(() => {
        if (attributeFilterOptions !== undefined) {
            return (_jsx(SelectorDisplay, Object.assign({ horizontalPadding: horizontalPadding, layout: optionLayout, stackLayout: "wrap" }, { children: attributeFilterOptions
                    .map((attributeFilterOptionProps, index) => (_createElement(AttributeFilter, Object.assign({}, attributeFilterOptionProps, { disabled: (isLoading || disabled) || ('disabled' in attributeFilterOptionProps ? attributeFilterOptionProps.disabled : undefined), key: index })))) })));
        }
        return undefined;
    }, [
        attributeFilterOptions,
        disabled,
        horizontalPadding,
        isLoading,
        optionLayout,
    ]);
    const pickerComponent = useMemo(() => {
        if (optionType === 'attributeIcon') {
            return (_jsx(AttributeIconPicker, Object.assign({ isLoading: isLoading, name: name, onChange: onChange, value: value }, { children: _jsx(SelectorDisplay, Object.assign({ horizontalPadding: horizontalPadding, layout: optionLayout, stackLayout: "wrap" }, { children: optionComponents })) })));
        }
        else if (optionType === 'custom'
            || optionType === 'customDefault'
            || optionType === 'customSwatch') {
            const modifiers = {
                custom: 'none',
                customDefault: 'default',
                customSwatch: 'swatch',
            };
            return (_jsx(Picker, Object.assign({ isLoading: isLoading, modifier: modifiers[optionType], name: name, onChange: onChange, selectionType: "single", value: value }, { children: _jsx(SelectorDisplay, Object.assign({ gridColumnMinimumWidth: 'gridColumnMinimumWidth' in props ? props.gridColumnMinimumWidth : undefined, horizontalPadding: horizontalPadding, layout: optionLayout, stackLayout: 'stackLayout' in props ? props.stackLayout : undefined }, { children: optionComponents })) })));
        }
        else if (optionType === 'select') {
            return (_jsx(Select, { ariaLabel: name, autoComplete: 'autoComplete' in props ? props.autoComplete : undefined, borderType: 'borderType' in props ? props.borderType : undefined, disabled: isLoading || disabled, id: 'id' in props ? props.id : undefined, name: name, onBlur: 'onBlur' in props ? props.onBlur : undefined, onChange: onChange, options: options, required: 'required' in props ? props.required : undefined, size: 'size' in props ? props.size : undefined, touched: 'touched' in props ? props.touched : undefined, value: value }));
        }
        else if (optionType === 'swatch') {
            return (_jsx(SwatchPicker, Object.assign({ isLoading: isLoading, name: name, onChange: onChange, selectionType: "single", shape: 'shape' in props ? props.shape : undefined, size: 'size' in props ? props.size : undefined, value: value }, { children: _jsxs(SelectorDisplay, Object.assign({ horizontalPadding: horizontalPadding, layout: optionLayout, stackLayout: "wrap" }, { children: [optionComponents, ('hasCustomColorSwatch' in props
                            && props.hasCustomColorSwatch)
                            ? (_jsx(CustomColorSwatch, { onClick: 'onCustomColorClick' in props ? props.onCustomColorClick : undefined, tooltipMinWidth: 'customColorSwatchTooltipMinWidth' in props ? props.customColorSwatchTooltipMinWidth : undefined, tooltipText: 'customColorSwatchTooltipText' in props ? props.customColorSwatchTooltipText : undefined }))
                            : undefined] })) })));
        }
        else if (optionType === 'shortText') {
            return (_jsx(ShortTextPicker, Object.assign({ isLoading: isLoading, name: name, onChange: onChange, selectionType: "single", size: 'size' in props ? props.size : undefined, value: value }, { children: _jsx(SelectorDisplay, Object.assign({ gridColumnMinimumWidth: 'gridColumnMinimumWidth' in props ? props.gridColumnMinimumWidth : undefined, horizontalPadding: horizontalPadding, layout: optionLayout, stackLayout: 'stackLayout' in props ? props.stackLayout : 'grid' }, { children: optionComponents })) })));
        }
        else if (optionType === 'longText') {
            const longTextPickerOptionLayoutStyles = css `
          display: inline-grid;
          grid-template-columns: repeat(1, 1fr);
          padding-left: ${styleUtils.rem(horizontalPadding || 0)};
          padding-right: ${styleUtils.rem(horizontalPadding || 0)};
          row-gap: ${theme.spacing.x2};
          width: 100%;
        `;
            return (_jsx(LongTextPicker, Object.assign({ isLoading: isLoading, name: name, onChange: onChange, selectionType: "single", value: value }, { children: _jsx("div", Object.assign({ css: longTextPickerOptionLayoutStyles }, { children: optionComponents })) })));
        }
        return undefined;
    }, [
        disabled,
        horizontalPadding,
        isLoading,
        name,
        onChange,
        optionComponents,
        options,
        optionType,
        props,
        optionLayout,
        value,
    ]);
    return (_jsxs("div", Object.assign({ css: containerStyles }, { children: [props.label && (_jsx("div", Object.assign({ css: optionSelectorHeadingContainerStyles }, { children: _jsx(OptionSelectorHeading, { description: description, isLoading: isLoading, label: props.label, layout: headingLayout, learnMoreText: props.learnMoreText, name: name, onLearnMoreClick: props.onLearnMoreClick, price: props.price, supportiveText: props.supportiveText }) }))), attributeFilterComponent, options ? pickerComponent : undefined] })));
};
const MemoizedOptionSelector = memo(OptionSelector);
export { MemoizedOptionSelector as OptionSelector };
// MC-1068 Temporary hack for Storybook.
export default OptionSelector;
